import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import { getFirstName } from "utils/helpers/getFirstName";

export function getButtonLabel(
  selectedAssistants: WintSuperkollAPIModelAnnualAccounts.AuditorAssistantOption[] | undefined
): string {
  const assistants = selectedAssistants ?? [];
  const firstName =
    assistants.length > 0 ? getFirstName(assistants[0].name) || assistants[0].socialSecurityNumber || "" : "";
  if (assistants.length === 0 || firstName.length === 0) {
    return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.ManageAssistants);
  }

  if (assistants.length === 1) {
    return LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.Reports.ManageAssistantsWithName,
      undefined,
      { name: firstName }
    );
  }

  return LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Reports.ManageAssistantsWithNameAndCount,
    undefined,
    { name: firstName, count: assistants.length - 1 }
  );
}
